import { SxProps, TableCell, TableSortLabel } from '@mui/material'
import { memo } from 'react'
import ThinArrowDownwardIcon from '../../assets/icons/ThinArrowDownwardIcon'
import { CustomColumnDef } from './CustomTable'

interface TableHeaderCellProps<T> {
    column: CustomColumnDef<T>
    index: number
    sxProps: SxProps | undefined
    columnLength: number
    verticalDividers: boolean
    sortField?: string
    sortDirection?: 'asc' | 'desc'
    handleSort: (field: string) => void
}

const TableHeaderCell = <T,>({ column, index, columnLength, sxProps, sortField, sortDirection, handleSort, verticalDividers = false }: TableHeaderCellProps<T>) => {
    const isSortable = Boolean(column.sortable)

    return (
        <TableCell
            align={column.align || 'left'}
            onClick={isSortable ? () => handleSort(column.field) : undefined}
            sx={{
                ...column.sx,
                ...(sxProps??{} as any),
                height:'21px !important',
                borderRight: verticalDividers && index < columnLength - 1 ? (theme) => `1px solid ${theme.palette.divider} !important` : 'none',
                ...(isSortable && {
                    cursor: 'default',
                    '& .MuiTableSortLabel-root': {
                        width: '100%',
                        cursor: 'default'
                    }
                })
            }}
            colSpan={column.colSpan !== undefined ? column.colSpan : 1}
            scope={(column?.colSpan ?? 1) > 1 ? 'colgroup' : 'col'}
        >
            {isSortable ? (
                <TableSortLabel
                    active={sortField === column.field}
                    direction={sortField === column.field ? sortDirection : 'asc'}
                    IconComponent={ThinArrowDownwardIcon}
                    sx={{
                        '& .MuiTableSortLabel-icon': {
                            margin: 0,
                            color: 'inherit'
                        }
                    }}
                >
                    {column.header}
                </TableSortLabel>
            ) : (
                column.header
            )}
        </TableCell>
    )
}

export default memo(TableHeaderCell) as <T>(props: TableHeaderCellProps<T>) => JSX.Element
